/*
 * 计划与报告模块接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 获取日常服务单的合同信息
    getContractList(data) {
        // return get('/app/service/bill/contract', data)
        return get('/wx/serviceBill/findServiceBill', data, 'javaHost')
    },
    // 获取日常服务单列表数据
    getServerOrderList(data) {
        // return get('/app/service/bill', data)
        return get('/wx/serviceBill/getServiceBill', data, 'javaHost')
    },
    // 获取日常服务单详情数据
    getServerOrderDetail(data) {
        // return get('/app/service/bill', data)
        return get('/serviceBill/getServiceBillDetails', data, 'javaHost')
    },

    // 添加日常服务单
    addServerOrder(data) {
        // return post('/app/service/bill', data)
        return post('/serviceBill/saveServiceBill', data, 'javaHost')
    },

    // 修改日常服务单
    updateServerOrder(data) {
        // return put('/app/service/bill', data)
        return post('/serviceBill/editServiceBill', data, 'javaHost')
    },

    // 删除改日常服务单
    deleteServerOrder(data) {
        // return del('/app/service/bill', data)
        return get('/serviceBill/delServiceBill', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/serverOrder.js